import { render, staticRenderFns } from "./lineFriend.vue?vue&type=template&id=253a223c&"
import script from "./lineFriend.vue?vue&type=script&lang=js&"
export * from "./lineFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports